// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__13BX4","footerMenu":"style_footerMenu__30Ey9","socialIcon":"style_socialIcon__1ID1d"};